import { NgModule } from '@angular/core';

import {appRoutes} from './app.routes';
import {RouterModule} from '@angular/router';
import {environment} from '../../environments/environment';

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { enableTracing: !environment.production, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
